import React from 'react';
import { motion } from 'framer-motion';
import {
  BarChart3,
  BellRing,
  BookOpenCheck,
  GalleryHorizontalEnd,
  Heart,
  SearchCheck,
  ShieldCheck,
  Store,
} from 'lucide-react';
import GlassCard from '@/components/ui/GlassCard';
import { productFeatures, type FeatureId } from '@/config/iphonefastflip';

const icons: Record<FeatureId, React.ElementType> = {
  marketplaces: Store,
  profitability: BarChart3,
  priceBooks: BookOpenCheck,
  personalization: SearchCheck,
  search: SearchCheck,
  favorites: Heart,
  details: GalleryHorizontalEnd,
  account: ShieldCheck,
};

const accentClasses = [
  'from-blue-500/20 to-cyan-500/10 text-blue-300',
  'from-emerald-500/20 to-blue-500/10 text-emerald-300',
  'from-violet-500/20 to-blue-500/10 text-violet-300',
  'from-cyan-500/20 to-blue-500/10 text-cyan-300',
];

const Features: React.FC = () => (
  <section id="funkcje" className="scroll-mt-24 px-4 py-20 sm:py-24">
    <div className="mx-auto max-w-7xl">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        className="mx-auto mb-14 max-w-3xl text-center"
      >
        <p className="section-eyebrow">Pełny warsztat łowcy okazji</p>
        <h2 className="section-title">Od znalezienia oferty do decyzji — w jednym miejscu.</h2>
        <p className="section-copy">
          Każdy moduł poniżej działa również w przeglądarce. Nie jest to uproszczone demo, tylko ta sama aplikacja i te same dane co w wersjach Android i Windows.
        </p>
      </motion.div>

      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4">
        {productFeatures.map((feature, index) => {
          const Icon = feature.id === 'favorites' ? BellRing : icons[feature.id];
          return (
            <motion.div
              key={feature.id}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ delay: (index % 4) * 0.06 }}
            >
              <GlassCard className="h-full p-6" hover>
                <div className={`mb-5 grid h-12 w-12 place-items-center rounded-2xl bg-gradient-to-br ${accentClasses[index % accentClasses.length]}`}>
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="text-xl font-bold tracking-tight text-white">{feature.title}</h3>
                <p className="mt-3 text-sm leading-6 text-slate-400">{feature.description}</p>
              </GlassCard>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);

export default Features;
